import { render, staticRenderFns } from "./dingdinglist.vue?vue&type=template&id=d55e635c&scoped=true&"
import script from "./dingdinglist.vue?vue&type=script&lang=js&"
export * from "./dingdinglist.vue?vue&type=script&lang=js&"
import style0 from "./dingdinglist.vue?vue&type=style&index=0&id=d55e635c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55e635c",
  null
  
)

export default component.exports